/**
 * Initializes the header states, adds a class when scrolling
 */
function initHeader() {
  const header = document.getElementById( 'header' );
  const menuItemsWithSubmenu = document.getElementsByClassName( 'nav-main__item--has-submenu' );
  const fraudNav = document.querySelector( '.header__fraud-nav' );
  const headerMain = document.querySelector( '.header__main' );

  const body = document.querySelector( 'body' );
  const bodyClasses = body.classList;

  window.onscroll = function (e) {
    let distanceScrolled = document.documentElement.scrollTop;

    header.classList.add( 'bg-white' );

    if (distanceScrolled === 0) {
      header.classList.remove( 'bg-white' );
    }

    if (fraudNav && headerMain && bodyClasses.contains( 'single-lesson' ) && distanceScrolled > 100) {
      fraudNav.classList.add( 'show' );
      headerMain.classList.remove( 'show' );
    } else {
      if (fraudNav) {
        fraudNav.classList.remove( 'show' );
      }

      if (headerMain) {
        headerMain.classList.add( 'show' );
      }
    }
  };

  [...menuItemsWithSubmenu].forEach( (element) => {
    element.addEventListener( 'mouseover', () => {
      header.classList.add( 'bg-white' );
    } );

    element.addEventListener( 'mouseout', () => {
      let distanceScrolled = document.documentElement.scrollTop;

      if (distanceScrolled === 0) {
        header.classList.remove( 'bg-white' );
      }
    } );
  } );
}

export default {
  init() {
    if (window.innerWidth > 1200) {
      initHeader();
    }
  },
};